import React from 'react'
import { makeStyles } from '@material-ui/core'
import { InsurancePlansList } from 'src/utils/constants/ValueAddedServicesData'

const MaternityInsurancePlanCard = () => {
  const classes = useStyles()
  return (
    <div className={classes.cardContainer}>
      {InsurancePlansList?.map((insurance, index) => {
        return (
          <div
            key={`${insurance?.insuranceName}${index}`}
            className={classes.cardContent}
          >
            <div className={classes.insuranceLogo}>
              <img src={insurance?.insuranceImage} alt='providerLogo' />
            </div>
            <div>
              <p className={classes.planTitle}>{insurance?.insuranceName}</p>
            </div>
            <div className={classes.featureHeading}>Features and Benefits:</div>
            <>
              <ul className={classes.featureList}>
                {insurance?.insuranceFeatures?.map((feature, featureIndex) => (
                  <li key={featureIndex} className={classes.feature}>
                    {feature}
                  </li>
                ))}
              </ul>
            </>
            <div>
              {/* <Button className={classes.enquiryButton}>Enquire Now</Button>*/}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default MaternityInsurancePlanCard

const useStyles = makeStyles({
  cardContainer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
  },
  insuranceLogo: {},
  featureList: {
    listStyleType: 'disc',
    marginLeft: '-25px',
  },
  feature: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#404040',
    lineHeight: '14.06px',
    paddingBottom: '10px',
  },
  planTitle: {
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '17.58px',
  },
  featureHeading: {
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '14.06px',
  },
  enquiryButton: {
    border: '1px  solid #EF669B !important',
    borderRadius: '20px',
    cursor: 'pointer  !important',
    color: '#EF669B !important',
    textTransform: 'unset !important',
    margin: 'unset',
    fontSize: '11px !important',
  },
  cardContent: {
    width: '286px',
    padding: '35px',
    border: '1px solid #CCCCCC',
    borderRadius: '10px',
  },
})
